import { createFileRoute } from '@tanstack/react-router'
import { insureSearchSchema } from '../../../src/schemas/routeSchemas'

export const Route = createFileRoute('/insure/rate-calculation')({
  validateSearch: (search) => insureSearchSchema.parse(search),
  loaderDeps: () => ({}),
})
